<template>
    <div class="faq-container"> 
        <div class="faq-container__left">  
            <div 
                v-for="item in faq.chunk_1"
                :key="item.id"
                class="faq"   
            >    
                <div 
                    class="faq__head" 
                    @click="toggle($event, item.id)"
                > 
                    <div class="faq__icon">
                        <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                width="14px" height="14px" viewBox="0 0 292.359 292.359" style="enable-background:new 0 0 292.359 292.359;"
                                xml:space="preserve">
                            <g>
                                <path d="M222.979,133.331L95.073,5.424C91.456,1.807,87.178,0,82.226,0c-4.952,0-9.233,1.807-12.85,5.424
                                    c-3.617,3.617-5.424,7.898-5.424,12.847v255.813c0,4.948,1.807,9.232,5.424,12.847c3.621,3.617,7.902,5.428,12.85,5.428
                                    c4.949,0,9.23-1.811,12.847-5.428l127.906-127.907c3.614-3.613,5.428-7.897,5.428-12.847
                                    C228.407,141.229,226.594,136.948,222.979,133.331z"/>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                        </svg>
                    </div>
                    <div class="faq__title faq__title_active">{{item.question.title}}</div>
                </div>

                <div class="faq__body" :ref="item.id"> 
                    <p v-for="(p, index) in item.answer.p" :key="index">{{p}}</p>

                    <ul 
                        v-if="item.answer.li" 
                        class="faq__list"
                    > 
                        <li 
                            class="faq__list-item"
                            v-for="(li, index) in item.answer.li"
                            :key="index"
                        >– 
                            <span v-if="li.title">{{li.title}}:</span> 
                            {{li.text}}
                        </li> 
                    </ul>
                </div>
            </div>  
        </div>

        <div class="faq-container__right"> 
            <div 
                v-for="item in faq.chunk_2"
                :key="item.id"
                class="faq"   
            >    
                <div 
                    class="faq__head" 
                    @click="toggle($event, item.id)"
                > 
                    <div class="faq__icon">
                        <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                width="14px" height="14px" viewBox="0 0 292.359 292.359" style="enable-background:new 0 0 292.359 292.359;"
                                xml:space="preserve">
                            <g>
                                <path d="M222.979,133.331L95.073,5.424C91.456,1.807,87.178,0,82.226,0c-4.952,0-9.233,1.807-12.85,5.424
                                    c-3.617,3.617-5.424,7.898-5.424,12.847v255.813c0,4.948,1.807,9.232,5.424,12.847c3.621,3.617,7.902,5.428,12.85,5.428
                                    c4.949,0,9.23-1.811,12.847-5.428l127.906-127.907c3.614-3.613,5.428-7.897,5.428-12.847
                                    C228.407,141.229,226.594,136.948,222.979,133.331z"/>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                        </svg>
                    </div>
                    <div class="faq__title faq__title_active">{{item.question.title}}</div>
                </div>

                <div class="faq__body" :ref="item.id"> 
                    <p v-for="(p, index) in item.answer.p" :key="index">{{p}}</p>

                    <ul 
                        v-if="item.answer.li" 
                        class="faq__list"
                    > 
                        <li 
                            class="faq__list-item"
                            v-for="(li, index) in item.answer.li"
                            :key="index"
                        >– 
                            <span v-if="li.title">{{li.title}}:</span> 
                            {{li.text}}
                        </li> 
                    </ul>
                </div>
            </div>   
        </div>
    </div>
</template>

<script>
import {faqData} from './faq';

export default {
    name: 'faq-list',
    data() {
        return {
            faq: faqData[this.$config.project]
        }
    },
    methods: {
        toggle(event, ref) { 
            const $el = this.$refs[ref];
            if (!$el) {
                return;
            } 
            
            const $head = event.target.closest('.faq__head');
            $el[0].classList.toggle('faq__body_show');
            $head.classList.toggle('faq__head_active')
        }
    }
}
</script>

<style lang="scss">
.faq-container {
    width: 100%;
    display: flex;
    flex-wrap: wrap; 

    &__left, &__right {
        width: 100%;
        max-width: 50%; 
    }
}

.faq {
    width: 100%;
    line-height: 1.5;
    padding-right: 50px;
    margin-bottom: 40px;

    &__body {
        display: none;

        p {
            margin-bottom: 16px;
        }

        &_show {
            display: block;
            animation: show ease-in .2s;
        }
    }

    &__list {
        list-style-type: none;
        padding: 0;

        &-item {

            span {
                color: #99cc00;
            }
        }
    }
    
    &__head {
        display: flex;
        align-items: center;
        margin: 8px 0 16px;
        cursor: pointer;
        user-select: none;

        &_active {
            svg {
                transform: rotate(90deg);
                path {
                    fill: #EC732F;
                }
            }

            .faq__title {
                color: #EC732F;
            }
        } 
    }

    &__title {
        font-size: 26px;
        margin-left: 16px; 
    }
    
}

@keyframes show {
    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
}

@media (max-width: 768px) {
   .faq {
       padding: 0 16px;

        &__title {
            font-size: 18px; 
        }
        
        &-container__left,
        &-container__right {
            width: 100%;
            max-width: 100%;
        }
   }   
}
</style>